// Live order tracking. Backend: real-time Firestore listener. Demo: poll the
// in-memory/localStorage store so status changes on the admin board show up.
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "./firebase";
import { isBackendConfigured } from "./catalog";
import { demoStore } from "./demoStore";
import type { Order } from "./types";

export function subscribeOrder(
  id: string,
  cb: (order: Order | null) => void,
): () => void {
  if (isBackendConfigured) {
    return onSnapshot(
      doc(db, "orders", id),
      (snap) =>
        cb(snap.exists() ? ({ id: snap.id, ...(snap.data() as Omit<Order, "id">) }) : null),
      () => cb(demoStore.getOrder(id)),
    );
  }
  cb(demoStore.getOrder(id));
  const iv = setInterval(() => cb(demoStore.getOrder(id)), 2000);
  return () => clearInterval(iv);
}
